import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const LockIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="nonzero"
          d="M15.75 10.69c1.12 0 2.02.9 2.02 2.02v4.05c0 1.12-.9 2.02-2.02 2.02H7.65c-1.12 0-2.02-.9-2.02-2.02v-4.05c0-1.12.9-2.02 2.02-2.02V8.67c0-2.23 1.82-4.05 4.05-4.05s4.05 1.82 4.05 4.05v2.02ZM11.7 5.96c1.49 0 2.7 1.21 2.7 2.7v2.02H9V8.66c0-1.49 1.21-2.7 2.7-2.7Zm4.05 6.08H7.65c-.37 0-.68.3-.68.68v4.05c0 .37.3.68.68.68h8.1c.37 0 .68-.3.68-.68v-4.05c0-.37-.3-.68-.68-.68Z"
          fill={color}
          stroke={color}
          strokeWidth={'0.2px'}
        />
      </svg>
    </div>
  );
};

export default LockIcon;
